import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/icons/quit.svg'


const _hoisted_1 = ["disabled"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  style: {"cursor":"pointer","width":"20px","height":"20px"},
  src: _imports_0
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "modal__title" }, " Welcome! ", -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { style: {"display":"flex","flex-direction":"column","align-items":"center","justify-content":"space-between","height":"85%"} }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-align-center",
  style: {"font-size":"20px","margin-bottom":"10px"}
}, [
  /*#__PURE__*/_createElementVNode("p", null, "We're thrilled to have you join our community of Creators. At TAWA, we're here to develop tools to support you on your journey. Tell us a bit about your needs so we can tailor the experience just for you ")
], -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", { style: {"color":"#9100FF","font-weight":"bolder","font-size":"18px"} }, "What is your primary reason for signing up on TAWA?")
], -1)
const _hoisted_10 = {
  class: "flex-row",
  style: {"flex-wrap":"wrap","gap":"10px","margin-top":"10px"}
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  style: {"margin-top":"10px"}
}
const _hoisted_13 = {
  class: "w-100",
  style: {"margin-top":"20px"}
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", { style: {"color":"#9100FF","font-weight":"bolder","font-size":"18px"} }, "Which stage best describes where you are in your journey as a Creator?")
], -1)
const _hoisted_15 = {
  class: "flex-column",
  style: {"flex-wrap":"wrap","gap":"10px","margin-top":"10px"}
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "radio-button" }, null, -1)
const _hoisted_18 = { style: {"cursor":"pointer"} }
const _hoisted_19 = {
  key: 1,
  style: {"margin-bottom":"130px"}
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", { style: {"color":"#9100FF","font-weight":"bolder","font-size":"18px"} }, "TAWA’s ecosystem is built to help Creators move forward. What is your next big project or goal?")
], -1)
const _hoisted_21 = {
  class: "flex-row",
  style: {"flex-wrap":"wrap","gap":"10px","margin-top":"10px"}
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 0,
  style: {"margin-top":"10px"}
}
const _hoisted_24 = {
  class: "add-campaign-btn-wrapper",
  style: {"align-self":"stretch"}
}
const _hoisted_25 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "modal__close",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
      disabled: _ctx.isLoading
    }, _hoisted_3, 8, _hoisted_1),
    _hoisted_4,
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_Spinner)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      (_ctx.step == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", null, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.influencer_platform_primary_goals, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["multiselect-label", {
                        'multiselect-label-selected': _ctx.formData.use_goals.some((goal) => item.value == goal.value) == true
                    }]),
                    key: item.value,
                    onClick: ($event: any) => (_ctx.selectGoal(item.label))
                  }, _toDisplayString(item.label), 11, _hoisted_11))
                }), 128))
              ]),
              (_ctx.isOtherGoal == true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.otherGoal) = $event)),
                      placeholder: "Type your reason",
                      style: {"padding":"5px"}
                    }, null, 512), [
                      [_vModelText, _ctx.otherGoal]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.influencer_content_creating_experience, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["radio-div", {
                        'radio-div-selected': _ctx.formData.influencer_marketing_experience == item.value
                    }]),
                    key: item.value,
                    onClick: ($event: any) => (_ctx.selectMarketingExperience(item.label))
                  }, [
                    _hoisted_17,
                    _createElementVNode("label", _hoisted_18, _toDisplayString(item.label), 1)
                  ], 10, _hoisted_16))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.step == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", null, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.creator_next_steps, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["multiselect-label", {
                        'multiselect-label-selected': _ctx.formData.campaign_objectives.some((goal) => item.value == goal.value) == true
                    }]),
                    key: item.value,
                    onClick: ($event: any) => (_ctx.selectObjective(item.label))
                  }, _toDisplayString(item.label), 11, _hoisted_22))
                }), 128))
              ]),
              (_ctx.isOtherObjective == true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.otherObjective) = $event)),
                      placeholder: "Type your next step",
                      style: {"padding":"5px"}
                    }, null, 512), [
                      [_vModelText, _ctx.otherObjective]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("button", {
          class: "add-campaign-btn-grp",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.save())),
          disabled: _ctx.isLoading
        }, _toDisplayString(_ctx.step == 2 ? 'Submit' : 'Next'), 9, _hoisted_25)
      ])
    ])
  ], 64))
}